
import React from 'react';
import { Card } from '@/components/ui/card';

interface MentionAutocompleteProps {
  users: any[];
  query: string;
  onSelect: (user: any) => void;
  onClose: () => void;
}

const MentionAutocomplete = ({ users, query, onSelect, onClose }: MentionAutocompleteProps) => {
  console.log('🔍 MentionAutocomplete: Received', users.length, 'group users for query:', query);

  // SECURITY FIX: Use only the passed group users, not all users
  const filteredUsers = users.filter((user) => {
    const username = user.username || user.first_name || '';
    const query_lower = query.toLowerCase();
    const username_lower = username.toLowerCase();
    
    // Match username or display name, but not exact matches (avoid self-completion)
    return username_lower.includes(query_lower) && username_lower !== query_lower;
  }).slice(0, 5); // Limit to 5 results

  console.log('🔍 Mention autocomplete - Query:', query, 'Filtered users:', filteredUsers.length);

  if (filteredUsers.length === 0) {
    return null;
  }

  const getUserDisplayName = (user: any) => {
    if (user.first_name && user.last_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    return user.username || user.first_name || 'Unknown User';
  };

  return (
    <Card className="absolute bottom-full left-0 w-full mb-2 bg-gray-800 border-gray-600 max-h-40 overflow-y-auto z-10">
      {filteredUsers.map((user, idx) => (
        <div
          key={user.id || `user-${idx}`}
          className="px-3 py-2 hover:bg-gray-700 cursor-pointer text-white border-b border-gray-600 last:border-b-0"
          onClick={() => onSelect(user)}
        >
          <div className="flex items-center justify-between">
            <div>
              <div className="font-medium">{getUserDisplayName(user)}</div>
              {user.username && (
                <div className="text-xs text-gray-400">@{user.username}</div>
              )}
            </div>
            <div className="text-xs text-gray-500 capitalize">
              {user.user_type}
            </div>
          </div>
        </div>
      ))}
    </Card>
  );
};

export default MentionAutocomplete;
